(function () {
  'use strict';

  function safeInit() {
    if (typeof window.AOS === 'undefined') return;
    window.AOS.init({
      duration: 600,
      easing: 'ease-out-cubic',
      once: true,
      offset: 80,
      disable: function () {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      },
    });
  }

  function safeRefresh() {
    if (typeof window.AOS === 'undefined') return;
    if (typeof window.AOS.refreshHard === 'function') {
      window.AOS.refreshHard();
    } else if (typeof window.AOS.refresh === 'function') {
      window.AOS.refresh();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', safeInit);
  } else {
    safeInit();
  }

  document.addEventListener('shopify:section:load', safeRefresh);
  document.addEventListener('shopify:section:unload', safeRefresh);
  document.addEventListener('shopify:block:select', safeRefresh);
})();
